import { useEventListener, useDebounceFn } from '@vueuse/core'

const getViewportHeight = () => Math.min(
  window.innerHeight,
  window.visualViewport?.height ?? Infinity
)

// iOS Chrome computes 100vh/100dvh on cold-launch (e.g. deep link from
// Mail/SMS) before its dynamic toolbar settles, and never relayouts unless a
// reflow is forced (switching tabs). Track the real viewport height in JS and
// re-check shortly after load to correct it without relying on that gesture.
export default class ViewportHeightProcedure {
  constructor () {
    this.name = 'viewportHeightProcedure'
  }

  applyHeight = () => {
    document.documentElement.style.setProperty('--height', `${getViewportHeight()}px`)
  }

  install = () => {
    const update = useDebounceFn(this.applyHeight, 50)

    this.applyHeight()
    this.lateChecks = [setTimeout(this.applyHeight, 300), setTimeout(this.applyHeight, 1000)]

    this.stopResize = useEventListener(window, 'resize', update)
    this.stopOrientation = useEventListener(window, 'orientationchange', update)
    this.stopVisualViewport = window.visualViewport
      ? useEventListener(window.visualViewport, 'resize', update)
      : () => {}
  }

  uninstall = () => {
    this.lateChecks?.forEach(clearTimeout)
    this.stopResize?.()
    this.stopOrientation?.()
    this.stopVisualViewport?.()
  }
}
